/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_External_Code_SaveInputs */

const en_case_field_external_code_save = /** @type {(inputs: Case_Field_External_Code_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save external identifier`)
};

const pt_br2_case_field_external_code_save = /** @type {(inputs: Case_Field_External_Code_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar identificador externo`)
};

/**
* | output |
* | --- |
* | "Save external identifier" |
*
* @param {Case_Field_External_Code_SaveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_external_code_save = /** @type {((inputs?: Case_Field_External_Code_SaveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_External_Code_SaveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_external_code_save(inputs)
	return pt_br2_case_field_external_code_save(inputs)
});